import {invokeApi} from '@/resource/js/GLOBAL2'
import {setOrderCache} from '@/resource/js/common'
import messageBox from '@/components/messageBox/messageBox'

console.log(process.env)
const state={

}
const getters={

}
const mutations = {

}
const actions = {
    getFiveActivePromotion(context,param){
        return new Promise((resolve,reject) => {
            invokeApi('promotion/getPromotionByBindCode', param, 'get', Math.random(), function(res) {
                if (res.error_code != null) {
                    messageBox(res.message)
                }else{
                    let data = res.value;
                    if(data.status==2){//待付款
                        messageBox(data.invalidReason,function(){
                            window.location.href = '/pages/order_list/order_list.html#/status1'
                        })
                    }else if(data.status==4||data.status==3||!data.valid){//4活动结束 3超过购买 不可售卖
                        messageBox(data.invalidReason,function(){
                            window.location.href = '/'
                        })
                    }else{
                        console.log(res.value)
                        resolve(res.value);
                    }

                }
            },true)
        })
    },
    getFiveActiveInvite(context,param){
        return new Promise((resolve,reject) => {
            invokeApi('fit/getActiveInvite', param, 'get', Math.random(), function(res) {
                resolve(res);
            })
        })
    },
    getFiveActiveStatus({},param){
        return new Promise((resolve,reject) => {
            invokeApi('fit/isJoinActive', param, 'get', Math.random(), function(res) {
                resolve(res);
            })
        })
    },
    submitCoupon({},param){
        return new Promise((resolve,reject) => {
            invokeApi('fit/prizeActive', param, 'get', Math.random(), function(res) {
                resolve(res);
            },true)
        })
    },
    getWxShareInfo({},param){
        return new Promise((resolve,reject) => {
            invokeApi('fit/getShare', param, 'get', Math.random(), function(res) {
                resolve(res);
            })
        })
    },
    submitFiveActiveTopay({},param){
        return new Promise((resolve,reject) => {
            setOrderCache(param.orderSource, param.bindCode, 1, 1, 1, {
                itemType: param.proType||1,
                itemId: param.proId,
                quantity: 1
            }, param.defined||{}, function (res) {
                if (res.transportType == 3) {
                    let payParam = {
                        "cacheType": 2,
                        "orderSource": res.orderSource,
                        "cacheId": res.cacheId,
                        "bindCode": res.bindCode,
                        "ticketCustomerId": '',
                        "addressId": '',
                        "deliverDate": '',
                        "deliverDate2": '',
                        "useAccountBalance": 0,
                        "payPassword": '',
                        "isOpenOrderPlan": res.isOpenOrderPlan,
                        "payType": 12,
                        "miniformId": "",
                        "giftType": 0
                    }
                    invokeApi('order/createOrderAndPay', {'orderCacheJson': encodeURIComponent(JSON.stringify(payParam))}, 'post', Math.random(), function(ret) {
                        console.log(ret)
                        resolve(ret);
                    })
                }else{
                    window.location.href = `/pages/topay/topay.html?orderSource=${res.orderSource}&bindCode=${res.bindCode}&cacheId=${res.cacheId}`
                }
            })

        })
    },
    getRedPacketInviteNum({},param){
        return new Promise((resolve,reject) => {
            invokeApi('redpackets/getInviteId', param, 'get', Math.random(), function(res) {
                resolve(res);
            })
        })
    },
    getGroupIndexOnList({},param){
        return new Promise((resolve,reject) => {
            invokeApi('groupon/getGrouponList', param, 'get', Math.random(), function(res) {
                resolve(res);
            })
        })
    },
    getGroupIndexSuccessList({},param){
        return new Promise((resolve,reject) => {
            invokeApi('groupon/getSuccessGrouponList', param, 'get', Math.random(), function(res) {
                resolve(res);
            })
        })
    },
    getGroupOpenGroupInfo({},param){
        return new Promise((resolve,reject) => {
            invokeApi('groupon/getGrouponByOrderNo', param, 'get', Math.random(), function(res) {
                resolve(res);
            })
        })
    },
    checkJoinGroupState({},param){
        return new Promise((resolve,reject) => {
            invokeApi('groupon/checkJoinGroupon', param, 'get', Math.random(), function(res) {
                resolve(res);
            })
        })
    },
    getRedPacketUserInfo({},param){
        return new Promise((resolve,reject) => {
            invokeApi('redpackets/checkSubscribe', param, 'get', Math.random(), function(res) {
                resolve(res);
            })
        })
    },
    getRedPacketInviteInfo({},param){
        return new Promise((resolve,reject) => {
            invokeApi('redpackets/takeRedPackege', param, 'get', Math.random(), function(res) {
                resolve(res);
            })
        })
    },
    takeRedPacket({},param){
        return new Promise((resolve,reject) => {
            invokeApi('redpackets/getInviteId', param, 'get', Math.random(), function(res) {
                resolve(res);
            })
        })
    },
}
export default {
    state,
    getters,
    mutations,
    actions
}


// WEBPACK FOOTER //
// ./src/store/modules/active.js